import React from "react";
import isEmail from "validator/lib/isEmail";
import _ from "lodash";
import { connect } from "react-redux";
import * as resActions from "../../modules/resources";
import Tabs from "Components/tabs/Tabs";
import Generals from "./settings/Generals";
import Security from "./settings/Security";
import Owner from "./settings/Owner";
import AddressbookData from "./settings/AddressbookData";
import Webmail from "./settings/Webmail";
import QboxmailApi from "../../qboxmailApi";
import withFormState from "Components/withFormState";
import { alertSuccess } from "Utils/alerts";
import PropTypes from "prop-types";
import { formatServerErrors } from "Utils/serverFormats";
import { t } from "i18next";

const formInitialState = {
  allow_nets: [],
};

const ContextTypes = {
  router: PropTypes.object,
  getLoggedUser: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
  isLoggedUserTrial: PropTypes.func,
};

class DomainSettingsPage extends React.Component {
  componentDidMount() {
    const {
      match: {
        params: { domainCode },
      },
      getOutboundLimits,
      domain,
    } = this.props;

    getOutboundLimits(domainCode);

    this.props.setInitialValues({
      ...domain,
      postmaster_password: "",
      postmaster_password_confirmation: "",
      allow_nets: domain.allow_nets[0] === "0.0.0.0/0" ? [] : domain.allow_nets,
      catch_all_destination: domain.catch_all_destination ? domain.catch_all_destination : "",
      plan: domain.plan && domain.plan.name,
    });
  }

  validate(values) {
    let errors = {};
    if (values.catch_all_enabled) {
      if (!isEmail(values.catch_all_destination)) {
        errors.catch_all_destination = "catch all destination is not a valid email address";
      }
    }
    return errors;
  }

  submitForm = (e, fieldsToSend, silent = false) => {
    e.preventDefault();
    const {
      refreshDomain,
      setFormLoading,
      unsetFormLoading,
      setFormErrors,
      formData,
      match: {
        params: { domainCode },
      },
    } = this.props;

    setFormLoading();

    const values = _.clone(formData);
    const errors = this.validate(formData);
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
    } else {
      const dataToSend = {};
      fieldsToSend.forEach((f) => (dataToSend[f] = values[f]));

      const api = new QboxmailApi({ useCookie: true });
      api
        .editDomain(domainCode, dataToSend)
        .then(() => {
          unsetFormLoading();

          if (silent) return;
          refreshDomain(domainCode);
          alertSuccess(t("alert.domainUpdateSuccess"));
        })
        .catch((response) => {
          formatServerErrors(response).then((errors) => {
            setFormErrors(errors);
            unsetFormLoading();
          });
        });
    }
  };

  render() {
    const { domain } = this.props;

    const loggedUser = this.context.getLoggedUser();
    let adminExtraTabs = {};
    if (this.context.isLoggedUserAdmin()) {
      adminExtraTabs[t("tab.owner")] = <Owner loggedUser={loggedUser} submitForm={this.submitForm} {...this.props} />;
    }

    let canEnableCatchAll;
    if (this.context.isLoggedUserAdmin()) {
      canEnableCatchAll = domain.customer_catch_all;
    } else {
      canEnableCatchAll = loggedUser.catch_all;
    }

    return (
      <Tabs
        {...this.props}
        newTagOnIndex={2}
        tabs={{
          [t("tab.registry")]: (
            <AddressbookData
              hasloggedUserCatchallEnabled={canEnableCatchAll}
              submitForm={this.submitForm}
              loggedUser={loggedUser}
              {...this.props}
              isLoggedUserAdmin={this.context.isLoggedUserAdmin()}
            />
          ),

          [t("tab.general")]: (
            <Generals
              hasloggedUserCatchallEnabled={canEnableCatchAll}
              submitForm={this.submitForm}
              loggedUser={loggedUser}
              {...this.props}
              isLoggedUserAdmin={this.context.isLoggedUserAdmin()}
              isLoggedUserTrial={this.context.isLoggedUserTrial()}
            />
          ),
          [t("tab.security")]: (
            <Security
              submitForm={this.submitForm}
              {...this.props}
              loggedUser={loggedUser}
              isLoggedUserAdmin={this.context.isLoggedUserAdmin()}
              updateDomainSecurityForm={this.props.updateDomainSecurityForm}
            />
          ),

          [t("tab.webmail")]: (
            <Webmail
              hasloggedUserCatchallEnabled={canEnableCatchAll}
              submitForm={this.submitForm}
              loggedUser={loggedUser}
              {...this.props}
              isLoggedUserAdmin={this.context.isLoggedUserAdmin()}
            />
          ),
          ...adminExtraTabs,
        }}
      />
    );
  }
}

DomainSettingsPage.contextTypes = ContextTypes;

const mapStateToProps = (state) => ({
  domain: resActions.getData("domain.data.0", state),
  isDomainLoading: resActions.isResourceLoading("domain", state),
  isDomainRefreshing: resActions.isResourceRefreshing("domain", state),
  outboundLimits: resActions.getData("outboundLimits.data", state),
});

const mapDispatchToProps = (dispatch) => ({
  getDomain: (code) => dispatch(resActions.callApi("getDomain", "domain", code)),
  refreshDomain: (code) => dispatch(resActions.callApi("refreshDomain", "domain", code)),
  getOutboundLimits: (code) => dispatch(resActions.callApi("getOutboundLimits", "outboundLimits", code)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withFormState(DomainSettingsPage, formInitialState));
